export const LinkName = {
    brand1: "https://play.marinabet.net/register?f=MDYxMjYxNDcxNw=="
}